export default __webpack_public_path__ + "static/img-10-41411b65d11a996b4bcec34b77709f71.jpg";